import type { GetCustomerOrderRequest, GetOrderByTrackingRequest, GetOrderRequest, GetOrdersRequest, GetUserOrdersRequest } from './types';

export const ORDER_QUERY_KEYS = {
  default: () => ['order'] as const,
  getOrder: (params: GetOrderRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrder', params] as const,
  getCustomerOrder: (params: GetCustomerOrderRequest) => [...ORDER_QUERY_KEYS.default(), 'getCustomerOrder', params] as const,
  getOrders: (params?: GetOrdersRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrders', params] as const,
  getUserOrders: ({ userId, cursor, limit }: GetUserOrdersRequest) => [...ORDER_QUERY_KEYS.default(), 'getUserOrders', { userId, cursor, limit }] as const,
  associateOrder: () => [...ORDER_QUERY_KEYS.default(), 'associateOrder'] as const,
  editShippingAddress: () => [...ORDER_QUERY_KEYS.default(), 'editShippingAddress'] as const,
  editBillingAddress: () => [...ORDER_QUERY_KEYS.default(), 'editBillingAddress'] as const,
  getOrderByTracking: (params: GetOrderByTrackingRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrderByTracking', params] as const,
};

